/*
 * سدر الخليج: المفضلة (STR-47)
 *
 * القائمة محفوظة في متصفح الزائر (localStorage، المفتاح sedr:wishlist). وللعميل المسجَّل تُحفظ في حسابه أيضًا
 * (STR-71): حقل sedr.wishlist عبر وكيل التطبيق /apps/sedr-wishlist، وما في المتصفح نسخة منه (قسم «المزامنة» أدناه).
 * ولا يُرسل شيء من قائمة الزائر غير المسجَّل.
 * كل عنصر: { id: رقم المنتج, h: الرابط المختصر, v: رقم الحجم أو null, p: السعر عند الحفظ بالهللة, c: العملة, t: وقت الحفظ, x: أول غياب عن المتجر }
 *
 * العناصر:
 *   <sedr-wishlist-button>  زر القلب في البطاقات وصفحة المنتج
 *   <sedr-wishlist-count>   العدد في رأس الصفحة
 *   <sedr-wishlist-page>    صفحة المفضلة (/search?view=wishlist)، وفيها وضع القائمة المشتركة (&shared=)
 *   <sedr-wishlist-strip>   «من مفضلتك» في السلة الجانبية
 * ومعها: تنبيه صغير (toast)، وتذكير عند العودة، وأحداث القياس.
 *
 * واجهة للاستعمال من خارج الملف: window.SedrWishlist
 */
(() => {
  if (window.SedrWishlist) return;

  const config = window.sedrWishlistConfig || { en: false, max: 60, pageUrl: '/search?view=wishlist', strings: {} };
  const S = config.strings || {};
  const KEY = 'sedr:wishlist';
  const MAX = config.max || 60;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const currency = () => (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  // عملة المتجر نفسها (سعر الصرف 1)، لا عملة محوّلة يتغيّر سعرها مع الصرف
  const baseCurrency = () => Number(window.Shopify?.currency?.rate) === 1;
  const MISSING_FOR = 30 * 24 * 60 * 60 * 1000;


const sedrRequest = async (url, options = {}) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(url, { ...options, signal: controller.signal });
    const body = await response.arrayBuffer();
    return new Response(body.byteLength ? body : null, {
      status: response.status, statusText: response.statusText, headers: response.headers,
    });
  } finally {
    clearTimeout(timer);
  }
};

  /* ------------------------------------------------------------------ أدوات */

  const t = (key, vars = {}) => (S[key] || '').replace(/\{(\w+)\}/g, (_, k) => (vars[k] ?? ''));

  // عدد المنتجات بصيغة عربية صحيحة: منتج واحد، منتجان، 3 منتجات، 11 منتجًا
  const countPhrase = (n) => {
    if (config.en) return n === 1 ? '1 item' : `${n} items`;
    if (n === 1) return 'منتج واحد';
    if (n === 2) return 'منتجان';
    if (n >= 3 && n <= 10) return `${n} منتجات`;
    return `${n} منتجًا`;
  };

  const track = (name, data = {}) => {
    try {
      window.Shopify?.analytics?.publish?.(`sedr_wishlist_${name}`, data);
    } catch (e) {}
    try {
      if (typeof window.clarity === 'function') window.clarity('event', `wishlist_${name}`);
    } catch (e) {}
  };

  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const idsQuery = (ids) => ids.map((id) => `id:${id}`).join(' OR ');

  const searchSectionUrl = (ids, sectionId) =>
    `${root}search?type=product&options%5Bunavailable_products%5D=last&q=${encodeURIComponent(idsQuery(ids))}&section_id=${sectionId}`;

  const parseHtml = (text) => new DOMParser().parseFromString(text, 'text/html');

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  /* ------------------------------------------------------------------ المخزن */

  let storageOk = true;

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.filter((i) => i && Number.isFinite(Number(i.id))).map((i) => ({ ...i, id: Number(i.id) }));
    } catch (e) {
      return [];
    }
  };

  const write = (items, detail) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
      storageOk = true;
    } catch (e) {
      storageOk = false;
      return false;
    }
    document.dispatchEvent(new CustomEvent('sedr:wishlist:change', { detail: { items, ...detail } }));
    return true;
  };

  const Store = {
    items: read,
    ids: () => read().map((i) => i.id),
    count: () => read().length,
    has: (id) => read().some((i) => i.id === Number(id)),
    get: (id) => read().find((i) => i.id === Number(id)),

    add(entry) {
      const items = read();
      const id = Number(entry.id);
      if (items.some((i) => i.id === id)) return 'exists';
      if (items.length >= MAX) return 'full';
      const item = {
        id,
        h: entry.h || '',
        v: entry.v ? Number(entry.v) : null,
        p: entry.p != null && entry.p !== '' && Number.isFinite(Number(entry.p)) ? Number(entry.p) : null,
        c: currency(),
        t: entry.t || Date.now(),
      };
      items.push(item);
      if (!write(items, { action: 'add', id })) return 'error';
      Sync.queue([{ op: 'add', item }]);
      return 'added';
    },

    remove(id) {
      id = Number(id);
      const items = read();
      const removed = items.find((i) => i.id === id);
      if (!removed) return null;
      if (write(
        items.filter((i) => i.id !== id),
        { action: 'remove', id }
      )) Sync.queue([{ op: 'remove', id }]);
      return removed;
    },

    // يعيد عنصرًا أُزيل (للتراجع) بترتيبه ووقته الأصليين
    restore(item) {
      const items = read();
      if (items.some((i) => i.id === item.id) || items.length >= MAX) return false;
      items.push(item);
      if (!write(items, { action: 'add', id: item.id })) return false;
      Sync.queue([{ op: 'add', item }]);
      return true;
    },

    // تحديث حقول عناصر قائمة (مثل x: أول مرة لم يُعثر فيها على المنتج) دون تغيير الترتيب
    patch(changes) {
      let changed = false;
      const ops = [];
      const items = read().map((i) => {
        if (!changes.has(i.id)) return i;
        const next = { ...i, ...changes.get(i.id) };
        Object.keys(next).forEach((k) => next[k] === undefined && delete next[k]);
        if ('x' in changes.get(i.id)) ops.push({ op: 'missing', id: i.id, x: next.x || null });
        changed = true;
        return next;
      });
      if (changed && write(items, { action: 'patch' })) Sync.queue(ops);
    },

    removeMany(ids) {
      const set = new Set(ids.map(Number));
      const items = read();
      if (write(
        items.filter((i) => !set.has(i.id)),
        { action: 'remove-many' }
      )) Sync.queue(items.filter((i) => set.has(i.id)).map((i) => ({ op: 'remove', id: i.id })));
    },

    clear() {
      const items = read();
      if (write([], { action: 'clear' })) Sync.queue(items.map((i) => ({ op: 'remove', id: i.id })));
    },
  };

  // مزامنة التبويبات الأخرى في المتصفح نفسه
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) {
      document.dispatchEvent(new CustomEvent('sedr:wishlist:change', { detail: { items: read(), action: 'sync' } }));
    }
  });

  /* ------------------------------------------------------------------ المزامنة مع حساب العميل (STR-71) */

  /*
   * للعميل المسجَّل: قائمة حسابه (حقل sedr.wishlist) هي المرجع، وتصل مع الصفحة من Liquid (config.account.list).
   * وما في المتصفح نسخة منها موسومة برقم صاحبها (owner). كل تعديل يُحفظ في المتصفح أولًا، ثم يُرسل تعديلًا صغيرًا
   * عبر وكيل التطبيق (POST /apps/sedr-wishlist/ops)، ويبقى في قائمة الانتظار (pending) حتى يؤكده الخادم.
   * فإن انقطع الخادم بقيت القائمة تعمل في المتصفح، وأُرسل المنتظر لاحقًا. والتعديلات تتكرر بلا ضرر:
   * إضافة الموجود وإزالة الغائب لا تغيّران شيئًا.
   *
   * الحالة (localStorage، sedr:wishlist:sync): { owner, base: آخر قائمة من الخادم, pending, at: وقت آخر تأكيد, orphan }
   *   - زائر بلا owner: لا مزامنة، كما في المرحلة الأولى.
   *   - دخول بقائمة زائر: تُدمج في الحساب مرة واحدة (إضافة لكل عنصر)، ثم تصير النسخة نسخة الحساب.
   *   - خروج: تُفرَّغ نسخة الحساب من المتصفح، ويُحفظ ما لم يُرسل لصاحبه وحده (orphan) أسبوعًا حتى يعود.
   *   - حساب آخر على الجهاز نفسه: لا يرى نسخة الأول ولا يدمجها.
   * ومسار الوكيل /apps/sedr-wishlist من إعداد التطبيق؛ إن غُيّر في المتجر توقفت المزامنة وبقيت القائمة في المتصفح.
   */
  const SYNC_KEY = 'sedr:wishlist:sync';
  const FRESH_KEY = 'sedr:wishlist:fresh';
  const RECENT = 2 * 60 * 1000;
  const ORPHAN_FOR = 7 * 24 * 60 * 60 * 1000;
  const BATCH = 30;
  const ATTEMPTS = 3;

  const Sync = (() => {
    const proxy = config.proxy || '';
    const account = proxy && config.account && config.account.id ? String(config.account.id) : null;
    // رقم صاحب الصفحة مع كل طلب: يرفض الخادم الطلب إن كان المسجَّل الآن غيره (صفحة قديمة من جلسة أخرى)
    const url = (path) => `${proxy}/${path}?expect=${encodeURIComponent(account || '')}`;
    let active = false;
    let timer = null;
    let busy = false;
    let stopped = false;
    let backoff = 0;
    let acks = 0;

    const readState = () => {
      try {
        const state = JSON.parse(localStorage.getItem(SYNC_KEY) || '{}');
        return state && typeof state === 'object' ? state : {};
      } catch (e) {
        return {};
      }
    };

    const saveState = (state) => {
      try {
        localStorage.setItem(SYNC_KEY, JSON.stringify(state));
        return true;
      } catch (e) {
        return false;
      }
    };

    const key = () => Math.random().toString(36).slice(2, 10);

    const toList = (raw) => ({
      name: raw && typeof raw.name === 'string' ? cleanName(raw.name, true) : '',
      items: (raw && Array.isArray(raw.items) ? raw.items : [])
        .filter((i) => i && Number.isFinite(Number(i.id)))
        .map((i) => ({ ...i, id: Number(i.id) }))
        .slice(0, MAX),
    });

    const pendingOf = (raw) => (Array.isArray(raw) ? raw.filter((o) => o && typeof o.op === 'string') : []);

    // ما لم يُرسل لعميل خرج: يبقى له وحده أسبوعًا
    const orphanOf = (state) => {
      const o = state.orphan;
      return o && o.owner && Date.now() - (o.at || 0) < ORPHAN_FOR ? o : null;
    };

    // القواعد نفسها في الخادم (applyOps في apps/sedr-wishlist/server.mjs)
    const apply = (list, ops) => {
      const next = { name: list.name || '', items: list.items.map((i) => ({ ...i })) };
      ops.forEach((o) => {
        if (o.op === 'add' && o.item) {
          const id = Number(o.item.id);
          const existing = next.items.find((i) => i.id === id);
          if (existing) {
            if (o.item.t && o.item.t < existing.t) existing.t = o.item.t;
          } else if (next.items.length < MAX) {
            const { x, ...item } = o.item;
            next.items.push({ ...item, id });
          }
        } else if (o.op === 'remove') {
          next.items = next.items.filter((i) => i.id !== Number(o.id));
        } else if (o.op === 'missing') {
          const item = next.items.find((i) => i.id === Number(o.id));
          if (item && o.x) item.x = o.x;
          else if (item) delete item.x;
        } else if (o.op === 'name') {
          next.name = cleanName(o.name, true);
        }
      });
      return next;
    };

    // يعرض القائمة في المتصفح دون أن يُنشئ تعديلات جديدة (action: 'account' تميّزها عن تعديل العميل وعن تبويب آخر)
    const show = (list) => {
      if (JSON.stringify(read()) !== JSON.stringify(list.items)) write(list.items, { action: 'account' });
      if (readName() !== list.name) storeName(list.name);
    };

    const locked = (task) => (navigator.locks ? navigator.locks.request('sedr-wishlist-sync', task) : task());

    // لا يُسرَّع الإرسال بنقرة وهو في مهلة انتظار بعد خطأ
    const schedule = (delay = 300) => {
      if (!active || stopped) return;
      clearTimeout(timer);
      timer = setTimeout(() => locked(send), Math.max(delay, backoff));
    };

    const retry = (min = 0) => {
      backoff = Math.max(min, Math.min(backoff ? backoff * 2 : 2000, 60000));
      schedule(backoff);
    };

    // يؤكد الخادم الدفعة فتُزال من الانتظار، وتصير قائمته هي الأساس، ويُعاد تطبيق ما لم يُرسل بعد عليها.
    // وقت التأكيد (at) يُحدَّث بعد إرسال فقط، لا بعد قراءة
    const accept = (list, sent = new Set(), ack = false) => {
      const state = readState();
      if (state.owner !== account) return null;
      state.pending = pendingOf(state.pending).filter((o) => !sent.has(o.k));
      if (list) state.base = toList(list);
      if (ack) state.at = Date.now();
      if (!saveState(state)) return null;
      if (state.base) show(apply(toList(state.base), state.pending));
      return state;
    };

    // دفعة يرفضها الخادم لخلل لا يزول بالإعادة: تُعاد في صفحات لاحقة، ثم تُترك بعد ATTEMPTS مرات حتى لا تعطّل ما بعدها
    const fail = (sent) => {
      const state = readState();
      if (state.owner !== account) return;
      state.pending = pendingOf(state.pending)
        .map((o) => (sent.has(o.k) ? { ...o, n: (o.n || 0) + 1 } : o))
        .filter((o) => (o.n || 0) < ATTEMPTS);
      saveState(state);
    };

    const send = async () => {
      if (busy || stopped) return;
      busy = true;
      try {
        const state = readState();
        const pending = pendingOf(state.pending);
        if (state.owner !== account || !pending.length) return;
        const batch = pending.slice(0, BATCH);
        const sent = new Set(batch.map((o) => o.k));
        let response;
        try {
          response = await sedrRequest(url('ops'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ops: batch.map(({ k, n, ...op }) => op) }),
          });
        } catch (e) {
          return retry();
        }
        const { status } = response;
        // الخادم أو Shopify مشغول أو معطّل، أو تعارض كتابتين: يبقى المنتظر ويُعاد لاحقًا
        if (status === 429) return retry(30000);
        if (status === 409 || status >= 500) return retry();
        // لم يعد العميل مسجَّلًا، أو المسجَّل الآن غير صاحب الصفحة: يبقى المنتظر لصفحة لاحقة
        if (status === 401 || status === 403) {
          const json = await response.json().catch(() => null);
          if (status === 403 && !(json && json.error === 'account')) fail(sent);
          stopped = true;
          return;
        }
        // 400: دفعة لا يقبلها الخادم أبدًا، فتُترك
        if (status === 400) {
          backoff = 0;
          if (!accept(null, sent)) stopped = true;
          return;
        }
        if (status !== 200) {
          fail(sent);
          stopped = true;
          return;
        }
        const json = await response.json().catch(() => null);
        if (!json || !json.ok) return retry();
        backoff = 0;
        acks++;
        const next = accept(json.list, sent, true);
        if (!next) stopped = true;
        else if (next.pending.length) schedule(0);
      } finally {
        busy = false;
      }
    };

    // قراءة القائمة من الخادم إن لم تصل من Liquid. لا تُطبَّق إن تغيّر شيء أثناءها
    const refresh = () =>
      locked(async () => {
        try {
          const before = readState().at || 0;
          const count = acks;
          const response = await sedrRequest(url('list'), { headers: { Accept: 'application/json' } });
          if (response.status === 401 || response.status === 403) stopped = true;
          if (!response.ok) return;
          const json = await response.json();
          const state = readState();
          // لا تُستبدل القائمة وفي الانتظار ما لم يُرسل (الإرسال يعيدها كاملة)، ولا إن أكّد الخادم إرسالًا بعد بدء القراءة
          if (!json || !json.ok || state.owner !== account || pendingOf(state.pending).length) return;
          if (acks !== count || (state.at || 0) !== before) return;
          accept(json.list);
          try {
            sessionStorage.setItem(FRESH_KEY, account);
          } catch (e) {}
        } catch (e) {}
      });

    const boot = () => {
      if (!proxy) return;
      const state = readState();
      const orphan = orphanOf(state);

      if (!account) {
        // خرج العميل: تُخفى قائمة حسابه، ويبقى ما لم يُرسل له وحده
        if (state.owner) {
          write([], { action: 'account' });
          storeName('');
          const pending = pendingOf(state.pending);
          saveState(pending.length ? { orphan: { owner: state.owner, pending, at: Date.now() } } : orphan ? { orphan } : {});
        }
        return;
      }

      const liquid = config.account.list ? toList(config.account.list) : null;
      let next;
      if (state.owner === account) {
        // بعد تأكيد قريب قد تكون قيمة Liquid أقدم منه، فالأساس المحفوظ أصح
        const recent = state.at && Date.now() - state.at < RECENT;
        next = { ...state, pending: pendingOf(state.pending), base: toList((!recent && liquid) || state.base || liquid) };
      } else {
        next = { owner: account, base: liquid || { name: '', items: [] }, pending: [], at: 0 };
        // عميل آخر كان هنا: لا يُدمج شيء من نسخته، ويبقى ما لم يُرسل له
        const previous = state.owner ? pendingOf(state.pending) : [];
        if (previous.length) next.orphan = { owner: state.owner, pending: previous, at: Date.now() };
        else if (orphan && orphan.owner !== account) next.orphan = orphan;
        if (orphan && orphan.owner === account) next.pending = pendingOf(orphan.pending);
        // لا owner: دخول من قائمة زائر، فتُدمج مرة واحدة
        if (!state.owner) {
          next.pending = next.pending.concat(read().map((item) => ({ op: 'add', item, k: key() })));
          // اسم الزائر للقائمة إن لم يكن للحساب اسم (ولا يُعرف ذلك إن لم تصل القائمة من Liquid)
          const guestName = readName();
          if (guestName && liquid && !liquid.name) next.pending.push({ op: 'name', name: guestName, k: key() });
        }
      }
      if (!saveState(next)) return;
      active = true;
      show(apply(next.base, next.pending));
      window.addEventListener('online', () => {
        backoff = 0;
        schedule(0);
      });

      let fresh = false;
      try {
        fresh = sessionStorage.getItem(FRESH_KEY) === account;
      } catch (e) {}
      if (next.pending.length) schedule(0);
      else if (!liquid && !fresh) refresh();
    };

    return {
      boot,
      queue(ops) {
        if (!active || !ops.length) return;
        const state = readState();
        if (state.owner !== account) return;
        state.pending = (state.pending || []).concat(ops.map((op) => ({ ...op, k: key() })));
        if (saveState(state)) schedule();
      },
    };
  })();

  /* ------------------------------------------------------------------ التنبيه الصغير */

  const Toast = (() => {
    let el, live, timer, onClose, duration, passive, drifts, scrollFrom;

    // منطقة الإعلان لقارئ الشاشة موجودة من تحميل الصفحة، فيُقرأ أول تنبيه أيضًا
    const ensureLive = () => {
      if (live || !document.body) return;
      live = document.createElement('div');
      live.className = 'sr-only';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    };

    const say = (message) => {
      ensureLive();
      if (!live) return;
      live.textContent = '';
      setTimeout(() => (live.textContent = message), 50);
    };

    const start = () => {
      clearTimeout(timer);
      timer = setTimeout(hide, duration);
    };

    // التأكيد العابر يزول حين يمضي الزائر في التمرير. ويبقى ما فيه «تراجع»، وما له زر إغلاق، ورسائل التعذّر (stay)
    const onScroll = () => {
      if (drifts && Math.abs(window.scrollY - scrollFrom) > 80) hide();
    };

    // فوق شريط الشراء الثابت في صفحة المنتج ما دام ظاهرًا، وينزل حين يختفي الشريط
    const place = () => {
      const bar = document.querySelector('product-quick-add.is-visible');
      const cs = bar && getComputedStyle(bar);
      const lift = cs && cs.position === 'fixed' ? bar.offsetHeight + (parseFloat(cs.bottom) || 0) + 12 : 0;
      el.style.setProperty('--sedr-wl-toast-lift', `${lift}px`);
    };
    // القالب يستبدل الشريط وحاويته عند كل تغيير للخيار: يُراقَب أبو الحاوية ويُعاد ربط الشريط الجديد
    const barWatch = new MutationObserver(() => {
      if (!el || el.hidden) return;
      watchBar();
      place();
    });
    const watchBar = () => {
      barWatch.disconnect();
      const bar = document.querySelector('product-quick-add');
      const holder = document.querySelector('product-rerender[id$="-sticky-bar"]');
      if (bar) barWatch.observe(bar, { attributes: true, attributeFilter: ['class'] });
      if (holder && holder.parentElement) barWatch.observe(holder.parentElement, { childList: true });
    };

    const ensure = () => {
      if (el) return el;
      el = document.createElement('div');
      el.className = 'sedr-wl-toast';
      el.hidden = true;
      // لا يختفي ومؤشر الفأرة أو التركيز عليه، فيتسع الوقت للضغط على «تراجع». واللمس لا يوقف العدّ
      el.addEventListener('pointerenter', (event) => event.pointerType === 'mouse' && clearTimeout(timer));
      el.addEventListener('pointerleave', (event) => event.pointerType === 'mouse' && (el.contains(document.activeElement) || start()));
      el.addEventListener('focusin', () => clearTimeout(timer));
      el.addEventListener('focusout', (event) => el.contains(event.relatedTarget) || el.matches(':hover') || start());

      // يُبعَد بسحبه إلى أسفل، وبلمسه خارج زره إن لم يكن فيه «تراجع» (لمسة تخطئ الزر لا تضيّعه)
      let from = null;
      el.addEventListener('pointerdown', (event) => {
        if (event.button || !event.isPrimary || event.target.closest('a, button')) return;
        from = event.clientY;
        try {
          el.setPointerCapture(event.pointerId);
        } catch (e) {}
      });
      el.addEventListener('pointermove', (event) => {
        if (from === null) return;
        el.classList.add('is-dragging');
        el.style.transform = `translateY(${Math.max(0, event.clientY - from)}px)`;
      });
      const release = (event) => {
        if (from === null) return;
        const moved = event.clientY - from;
        from = null;
        el.classList.remove('is-dragging');
        if (event.type === 'pointerup' && (moved > 16 || (passive && Math.abs(moved) < 6))) return hide();
        el.style.transform = '';
        // ضغطة فأرة انتهت والمؤشر ما زال فوقه: العدّ موقوف حتى يغادر
        if (!(event.pointerType === 'mouse' && el.matches(':hover'))) start();
      };
      el.addEventListener('pointerup', release);
      el.addEventListener('pointercancel', release);

      document.body.appendChild(el);
      return el;
    };

    const hide = () => {
      if (!el || el.hidden) return;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      barWatch.disconnect();
      el.classList.remove('is-visible');
      const shown = el.firstChild;
      const done = () => {
        // تنبيه جديد ظهر قبل أن يكتمل زوال السابق: لا يُمحى
        if (el.classList.contains('is-visible') || el.firstChild !== shown) return;
        el.hidden = true;
        el.style.transform = '';
        el.replaceChildren();
      };
      // يبقى في موضعه لحظة حتى مع «تقليل الحركة»، فلا تنفذ اللمسة التي أبعدته إلى ما تحته
      setTimeout(done, 200);
      if (onClose) {
        const cb = onClose;
        onClose = null;
        cb();
      }
    };

    /**
     * message: النص
     * action: { label, href } أو { label, onClick }
     * options: { duration, closable, stay, icon, onClose, once }
     */
    const show = (message, action = null, options = {}) => {
      // once: التأكيد نفسه يظهر مرة في الزيارة، وبعدها يكفي امتلاء القلب؛ ويبقى معلنًا لقارئ الشاشة
      if (options.once) {
        let told = false;
        try {
          told = !!sessionStorage.getItem(`${TOLD_KEY}:${options.once}`);
          sessionStorage.setItem(`${TOLD_KEY}:${options.once}`, '1');
        } catch (e) {}
        if (told) {
          hide();
          say(message);
          return;
        }
      }

      ensure();
      clearTimeout(timer);
      onClose = null;
      el.replaceChildren();
      el.style.transform = '';

      place();
      watchBar();

      if (options.icon) {
        const icon = document.createElement('span');
        icon.className = 'sedr-wl-toast__icon';
        icon.innerHTML = HEART_SVG;
        if (options.icon === 'filled') icon.classList.add('is-filled');
        el.appendChild(icon);
      }

      const text = document.createElement('span');
      text.className = 'sedr-wl-toast__text';
      text.textContent = message;
      el.appendChild(text);

      if (action) {
        const a = document.createElement(action.href ? 'a' : 'button');
        a.className = 'sedr-wl-toast__action';
        a.textContent = action.label;
        if (action.href) a.href = action.href;
        else a.type = 'button';
        a.addEventListener('click', (event) => {
          if (action.onClick) {
            event.preventDefault();
            action.onClick();
            hide();
          }
        });
        el.appendChild(a);
      }

      if (options.closable) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'sedr-wl-toast__close';
        close.setAttribute('aria-label', S.close || 'Close');
        close.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
        close.addEventListener('click', hide);
        el.appendChild(close);
      }

      el.hidden = false;
      void el.offsetWidth; // يبدأ الظهور المتدرج من الحالة المخفية
      el.classList.add('is-visible');
      onClose = options.onClose || null;
      duration = options.duration || (action ? 5000 : 3000);
      passive = !(action && action.onClick);
      drifts = passive && !options.closable && !options.stay;
      scrollFrom = window.scrollY;
      window.addEventListener('scroll', onScroll, { passive: true });
      start();
      say(action && action.onClick ? `${message}. ${action.label}` : message);
    };

    return { show, hide, ensureLive };
  })();

  const TOLD_KEY = 'sedr:wishlist:told';

  const HEART_SVG =
    '<svg class="sedr-wl-heart" width="18" height="18" viewBox="0 0 22 22" fill="none" stroke-width="1.5" aria-hidden="true" focusable="false"><path class="sedr-wl-heart__fill" d="M11 19.25S2.75 14.3 2.75 8.2A4.45 4.45 0 0 1 11 5.9a4.45 4.45 0 0 1 8.25 2.3c0 6.1-8.25 11.05-8.25 11.05Z" stroke="currentColor" stroke-linejoin="round"/></svg>';

  /* ------------------------------------------------------------------ زر القلب */

  class SedrWishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this._onClick = this._onClick.bind(this);
      this._sync = this._sync.bind(this);
      this._onVariantChange = this._onVariantChange.bind(this);

      this.button.addEventListener('click', this._onClick);
      document.addEventListener('sedr:wishlist:change', this._sync);

      // في صفحة المنتج: الحجم المختار يتبع اختيار الزائر
      this.section = this.closest('.shopify-section');
      if (this.hasAttribute('variant-id') && this.section) {
        this.section.addEventListener('variant:change', this._onVariantChange);
      }

      this._sync();
    }

    disconnectedCallback() {
      if (!this.button) return;
      this.button.removeEventListener('click', this._onClick);
      document.removeEventListener('sedr:wishlist:change', this._sync);
      this.section?.removeEventListener('variant:change', this._onVariantChange);
    }

    get productId() {
      return Number(this.getAttribute('product-id'));
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;
      this.setAttribute('variant-id', variant.id);
      if (Number.isFinite(Number(variant.price))) this.setAttribute('price', variant.price);
    }

    _sync() {
      const saved = Store.has(this.productId);
      this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      this.classList.toggle('is-saved', saved);
      const text = this.querySelector('.sedr-wl-button__text');
      if (text) text.textContent = saved ? S.savedLabel || '' : S.saveLabel || '';
    }

    _pop() {
      if (reducedMotion()) return;
      this.classList.remove('is-popping');
      void this.offsetWidth;
      this.classList.add('is-popping');
      setTimeout(() => this.classList.remove('is-popping'), 450);
    }

    _onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      const id = this.productId;
      const onWishlistPage = !!document.querySelector('sedr-wishlist-page');

      if (Store.has(id)) {
        const removed = Store.remove(id);
        track('remove', { productId: id });
        Toast.show(S.removed, removed ? { label: S.undo, onClick: () => Store.restore(removed) } : null, { icon: 'outline' });
        return;
      }

      const result = Store.add({
        id,
        h: this.getAttribute('handle'),
        v: this.getAttribute('variant-id'),
        p: this.getAttribute('price'),
      });

      if (result === 'full') {
        Toast.show(S.full, { label: S.view, href: config.pageUrl }, { duration: 6000, stay: true });
      } else if (result === 'error') {
        Toast.show(S.noStorage, null, { duration: 6000, stay: true });
      } else if (result === 'added') {
        this._pop();
        track('add', { productId: id, variantId: this.getAttribute('variant-id') || null });
        Toast.show(S.saved, onWishlistPage ? null : { label: S.view, href: config.pageUrl }, { icon: 'filled', duration: 3200, once: 'saved' });
      }
    }
  }

  /* ------------------------------------------------------------------ العدد في رأس الصفحة */

  class SedrWishlistCount extends HTMLElement {
    connectedCallback() {
      this._sync = this._sync.bind(this);
      document.addEventListener('sedr:wishlist:change', this._sync);
      this._sync();
    }

    disconnectedCallback() {
      document.removeEventListener('sedr:wishlist:change', this._sync);
    }

    _sync(event) {
      const count = Store.count();
      const previous = Number(this.textContent) || 0;
      this.textContent = count > 0 ? String(count) : '';
      this.hidden = count === 0;
      const link = this.closest('a');
      if (link && link.dataset.label) {
        link.setAttribute('aria-label', count > 0 ? `${link.dataset.label} (${countPhrase(count)})` : link.dataset.label);
      }
      if (event && count > previous && !reducedMotion()) {
        this.classList.remove('is-bumping');
        void this.offsetWidth;
        this.classList.add('is-bumping');
      }
    }
  }

  /* ------------------------------------------------------------------ صفحة المفضلة */

  // رابط المشاركة: shared=123-456.789 (رقم المنتج، ثم الحجم إن حُفظ)
  const encodeShared = (items) => items.map((i) => (i.v ? `${i.id}-${i.v}` : `${i.id}`)).join('.');

  const decodeShared = (value) =>
    (value || '')
      .split(/[.,\s]+/)
      .slice(0, MAX * 2)
      .map((part) => {
        const [id, v] = part.split('-').map(Number);
        return Number.isFinite(id) && id > 0 ? { id, v: Number.isFinite(v) && v > 0 ? v : null } : null;
      })
      .filter(Boolean)
      .filter(function (item) {
        if (this.has(item.id)) return false;
        this.add(item.id);
        return true;
      }, new Set())
      .slice(0, MAX);

  // اسم القائمة المشتركة (&name=): حروف ومسافات وعلامات قليلة فقط، بلا أرقام ولا روابط،
  // حتى لا يُستعمل الرابط لعرض رقم هاتف أو عنوان موقع باسم المتجر. وحده 40 حرفًا.
  const NAME_KEY = 'sedr:wishlist:name';
  const NAME_MAX = 40;

  const cleanName = (value, final = false) => {
    let name = String(value || '')
      .replace(/[^\p{L}\p{M} '’&()«»\-،,]/gu, '')
      .replace(/[\u115F\u1160\u3164\uFFA0]/g, '') // حروف فارغة لا تُرى
      .replace(/(\p{M}{2})\p{M}+/gu, '$1') // لا أكثر من علامتين على الحرف
      .replace(/ {2,}/g, ' ');
    if (final) name = name.trim();
    return Array.from(name).slice(0, NAME_MAX).join('');
  };

  const readName = () => {
    try {
      return cleanName(localStorage.getItem(NAME_KEY), true);
    } catch (e) {
      return '';
    }
  };

  const storeName = (name) => {
    try {
      if (name) localStorage.setItem(NAME_KEY, name);
      else localStorage.removeItem(NAME_KEY);
    } catch (e) {}
  };

  const saveName = (name) => {
    if (name === readName()) return;
    storeName(name);
    Sync.queue([{ op: 'name', name }]);
  };

  class SedrWishlistPage extends HTMLElement {
    connectedCallback() {
      const params = new URLSearchParams(window.location.search);
      this.shared = params.has('shared') ? decodeShared(params.get('shared')) : null;
      this.isShared = this.shared !== null;
      this.sharedName = this.isShared ? cleanName(params.get('name'), true) : '';

      this.list = this.querySelector('[data-sedr-wl-list]');
      this.status = this.querySelector('[data-sedr-wl-status]');
      this.shareButton = this.querySelector('[data-sedr-wl-share]');
      this.shareForm = this.querySelector('[data-sedr-wl-share-form]');
      this.nameInput = this.shareForm?.querySelector('input');
      this.heading = this.querySelector('h1');
      this.emptyTitle = this.querySelector('[data-sedr-wl-empty-title]');
      this.emptyText = this.querySelector('[data-sedr-wl-empty-text]');

      this._onChange = this._onChange.bind(this);
      document.addEventListener('sedr:wishlist:change', this._onChange);

      this.querySelector('[data-sedr-wl-add-all]')?.addEventListener('click', () => this.addAll());
      this.shareButton?.addEventListener('click', () => this.toggleShare());
      this.shareForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.share();
      });
      this.nameInput?.addEventListener('input', (event) => {
        if (event.isComposing) return;
        const value = cleanName(this.nameInput.value);
        if (value !== this.nameInput.value) this.nameInput.value = value;
      });
      this.querySelector('[data-sedr-wl-save-shared]')?.addEventListener('click', () => this.saveShared());
      this.querySelector('[data-sedr-wl-clear]')?.addEventListener('click', () => this.clear());

      // قياس الإضافة إلى السلة من بطاقات الصفحة (زر الإضافة السريعة في البطاقة)
      this.addEventListener('variant:add', (event) => {
        const items = event.detail?.items || [];
        items.forEach((i) => track('item_to_cart', { productId: i.product_id, variantId: i.variant_id, source: this.isShared ? 'shared' : 'page' }));
      });

      if (this.isShared) {
        this.querySelector('[data-sedr-wl-intro]').hidden = true;
        this.querySelector('[data-sedr-wl-shared-intro]').hidden = false;
        const title = this.querySelector('[data-sedr-wl-title]');
        // بالاسم: «قائمة مفضلة مشتركة» سطرًا صغيرًا، والاسم عنوانًا (نصًا لا HTML)
        if (title) title.textContent = this.sharedName || title.dataset.sharedTitle;
        if (this.sharedName) this.querySelector('[data-sedr-wl-eyebrow]').hidden = false;
        this.shareButton.hidden = true;
        this.querySelector('[data-sedr-wl-save-shared]').hidden = false;
        track('shared_view', { count: this.shared.length, named: Boolean(this.sharedName) });
      }

      const heading = this.isShared ? this.sharedName || S.sharedTitle : S.pageTitle;
      document.title = config.shopName ? `${heading} – ${config.shopName}` : heading;

      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('sedr:wishlist:change', this._onChange);
    }

    // العناصر بترتيب العرض: الأحدث أولًا في قائمة الزائر، وبترتيب الرابط في القائمة المشتركة
    get entries() {
      if (this.isShared) return this.shared;
      return Store.items().sort((a, b) => (b.t || 0) - (a.t || 0));
    }

    setState(state, { unavailable = false } = {}) {
      this.dataset.state = state;
      const empty = state === 'empty';
      if (empty) {
        const kind = this.isShared ? 'shared' : unavailable ? 'unavailable' : 'own';
        [this.emptyTitle, this.emptyText].forEach((el, index) => {
          if (!el) return;
          el.dataset.own ??= el.textContent;
          const custom = { shared: [S.sharedEmptyTitle, S.sharedEmptyText], unavailable: [S.unavailableTitle, S.unavailableText] }[kind];
          el.textContent = custom ? custom[index] : el.dataset.own;
        });
      }
      this.querySelector('[data-sedr-wl-loading]').hidden = state !== 'loading';
      this.querySelector('[data-sedr-wl-empty]').hidden = !empty;
      this.querySelector('[data-sedr-wl-actions]').hidden = state !== 'ready';
      this.querySelector('[data-sedr-wl-footer]').hidden = state !== 'ready' || this.isShared;
      if (state !== 'ready' && this.shareForm) this.toggleShare(false);
      this.list.hidden = state !== 'ready';
      this.updateCount();
    }

    updateCount() {
      const bubble = this.querySelector('[data-sedr-wl-page-count]');
      const count = this.list.querySelectorAll('[data-sedr-wl-item]').length;
      if (bubble) {
        bubble.textContent = count ? String(count) : '';
        bubble.hidden = !count || this.dataset.state !== 'ready';
      }
    }

    async fetchItems(entries) {
      const found = new Map();

      // دفعة واحدة من البحث بأرقام المنتجات
      try {
        const response = await sedrRequest(searchSectionUrl(entries.map((e) => e.id), 'sedr-wishlist-items'));
        if (response.ok) {
          parseHtml(await response.text())
            .querySelectorAll('[data-sedr-wl-item]')
            .forEach((el) => found.set(Number(el.dataset.productId), el));
        }
      } catch (e) {}

      // ما لم يظهر في البحث (مخفي من البحث مثلًا) يُطلب من صفحته، إن عُرف رابطه، أربعة طلبات في المرة
      const queue = entries.filter((e) => !found.has(e.id) && e.h);
      const missing = []; // لم يُعثر عليه الآن: قد يكون مسودة أو غير معروض مؤقتًا، فلا يعني أنه حُذف

      const worker = async () => {
        for (let entry = queue.shift(); entry; entry = queue.shift()) {
          try {
            const response = await sedrRequest(`${root}products/${encodeURIComponent(entry.h)}?section_id=sedr-wishlist-items`);
            if (response.status === 404) {
              missing.push(entry.id);
              continue;
            }
            if (!response.ok) continue;
            const doc = parseHtml(await response.text());
            const el = doc.querySelector('[data-sedr-wl-item]');
            // عرض الأقسام يردّ 200 بغلاف فارغ للرابط غير الموجود
            if (!el) {
              if (doc.querySelector('.sedr-wl-items')) missing.push(entry.id);
              continue;
            }
            // قد يتغيّر الرابط المختصر مع بقاء المنتج نفسه (يحوّله Shopify إلى الجديد)
            if (Number(el.dataset.productId) === entry.id) found.set(entry.id, el);
            else missing.push(entry.id);
          } catch (e) {}
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, queue.length) }, worker));

      return { found, missing };
    }

    // keep: القائمة معروضة وتغيّرت من غير العميل (من حسابه مثلًا)، فتبقى ظاهرة حتى تصل البطاقات الجديدة
    async render({ keep = false } = {}) {
      const entries = this.entries;
      this._renderToken = (this._renderToken || 0) + 1;
      const token = this._renderToken;

      // يبقى التركيز على الزر نفسه في البطاقة نفسها بعد إعادة البناء
      const active = document.activeElement;
      const card = active && this.list.contains(active) ? active.closest('[data-sedr-wl-item]') : null;
      const focus = card ? { id: card.dataset.productId, index: Array.from(card.querySelectorAll(FOCUSABLE)).indexOf(active) } : null;

      if (!entries.length) {
        this.list.replaceChildren();
        this.setState('empty');
        return;
      }

      if (!keep || this.dataset.state !== 'ready') this.setState('loading');
      const { found, missing } = await this.fetchItems(entries);
      if (token !== this._renderToken) return;

      // ما لم يُعثر عليه يبقى في قائمة الزائر مخفيًا، ويعود إن عاد المنتج إلى المتجر.
      // ولا يُزال إلا إن غاب 30 يومًا متصلة (x: أول مرة غاب فيها)
      let hiddenNow = 0;
      if (!this.isShared) {
        const now = Date.now();
        const changes = new Map();
        const expired = [];
        missing.forEach((id) => {
          const entry = entries.find((e) => e.id === id);
          if (!entry.x) changes.set(id, { x: now });
          else if (now - entry.x > MISSING_FOR) expired.push(id);
        });
        entries.forEach((e) => e.x && found.has(e.id) && changes.set(e.id, { x: undefined }));
        hiddenNow = missing.length - expired.length;

        this._silent = true;
        if (changes.size) Store.patch(changes);
        if (expired.length) Store.removeMany(expired);
        this._silent = false;

        const notes = [];
        if (expired.length) notes.push(t('missing', { count: countPhrase(expired.length) }));
        if (hiddenNow) notes.push(t('hiddenNow', { count: countPhrase(hiddenNow) }));
        // لا تُكرَّر الملاحظة نفسها مع كل إعادة بناء
        const note = notes.join(' ');
        if (note && note !== this._lastNote) this.announce(note);
        this._lastNote = note;
      }

      const nodes = [];
      entries.forEach((entry) => {
        const el = found.get(entry.id);
        if (!el) return;
        const node = document.importNode(el, true);
        this.decorate(node, entry);
        nodes.push(node);
      });

      this.list.replaceChildren(...nodes);
      this.setState(nodes.length ? 'ready' : 'empty', { unavailable: hiddenNow > 0 });

      if (focus) {
        const same = nodes.find((node) => node.dataset.productId === focus.id);
        const target = same ? same.querySelectorAll(FOCUSABLE)[focus.index] || same.querySelector(FOCUSABLE) : null;
        (target || this.heading)?.focus({ preventScroll: Boolean(target) });
      }
    }

    variantsOf(node) {
      try {
        return JSON.parse(node.querySelector('[data-sedr-wl-variants]').textContent);
      } catch (e) {
        return [];
      }
    }

    // الملاحظات تحت البطاقة: الحجم المحفوظ وتوفره، وانخفاض السعر منذ الحفظ
    decorate(node, entry) {
      const variants = this.variantsOf(node);
      const note = node.querySelector('[data-sedr-wl-note]');
      if (!note) return;
      const parts = [];

      const saved = entry.v ? variants.find((v) => v.id === entry.v) : null;
      if (saved && variants.length > 1) {
        parts.push({ text: t('savedSize', { size: saved.title }) });
        if (!saved.available && node.dataset.available === 'true') parts.push({ text: S.soldOut, cls: 'is-muted' });
      }

      // «انخفض سعره» للحجم نفسه الذي حُفظ سعره وحده، وبعملة المتجر وحدها لأن سعر الصرف يتغيّر:
      // المحفوظ بحجمه يُقارن بذلك الحجم، والمحفوظ بلا حجم يُقارن إن بقي للمنتج حجم واحد فقط
      const sameVariant = saved || (!entry.v && variants.length === 1 ? variants[0] : null);
      if (!this.isShared && sameVariant && Number.isFinite(entry.p) && entry.c === currency() && baseCurrency()) {
        const current = Number(sameVariant.price);
        if (Number.isFinite(current) && current < entry.p) parts.unshift({ text: S.priceDrop, cls: 'is-positive' });
      }

      if (!parts.length) return;
      note.replaceChildren(
        ...parts.map((p) => {
          const span = document.createElement('span');
          span.textContent = p.text;
          if (p.cls) span.className = p.cls;
          return span;
        })
      );
      note.hidden = false;
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      setTimeout(() => (this.status.textContent = message), 50);
    }

    _onChange(event) {
      const action = event?.detail?.action;
      if (this.isShared || this._silent || action === 'patch') return;
      if (this.dataset.state === 'loading') return this.render();
      const ids = new Set(Store.ids());
      const cards = Array.from(this.list.querySelectorAll('[data-sedr-wl-item]'));
      const rendered = new Set(cards.map((c) => Number(c.dataset.productId)));
      const added = [...ids].filter((id) => !rendered.has(id));
      const leaving = cards.filter((card) => !ids.has(Number(card.dataset.productId)));

      // تغيير وصل من حساب العميل (من جهاز آخر مثلًا): يُعلَن لقارئ الشاشة لأنه لم يأتِ من فعل العميل هنا
      if (action === 'account' && (added.length || leaving.length)) {
        const parts = [];
        if (added.length) parts.push(t('accountAdded', { count: countPhrase(added.length) }));
        if (leaving.length) parts.push(t('accountRemoved', { count: countPhrase(leaving.length) }));
        this.announce(parts.join(' '));
      }

      // إضافة (كالتراجع أو من تبويب آخر أو من الحساب): يُعاد بناء القائمة
      if (added.length) {
        this.render({ keep: action === 'account' || action === 'sync' });
        return;
      }

      // إزالة: تختفي البطاقة بهدوء، وينتقل التركيز إن كان فيها إلى البطاقة المجاورة أو العنوان
      const focused = leaving.find((card) => card.contains(document.activeElement));
      let focusTarget = null;
      if (focused) {
        const staying = cards.filter((card) => !leaving.includes(card));
        const index = cards.indexOf(focused);
        const next = staying.find((card) => cards.indexOf(card) > index) || staying[staying.length - 1];
        focusTarget = next?.querySelector('sedr-wishlist-button button') || next?.querySelector('a[href], button') || this.heading;
      }

      leaving.forEach((card) => {
          const done = () => {
            card.remove();
            if (!this.list.querySelector('[data-sedr-wl-item]')) this.setState('empty');
            else this.updateCount();
            if (focusTarget && card === focused) focusTarget.focus({ preventScroll: focusTarget !== this.heading });
          };
          if (reducedMotion()) return done();
          card.classList.add('is-leaving');
          setTimeout(done, 220);
        });
    }

    /* «أضف الكل إلى السلة»: الحجم المحفوظ، أو الحجم الوحيد؛ ولا يُخمَّن الحجم أبدًا */
    async addAll() {
      const button = this.querySelector('[data-sedr-wl-add-all]');
      if (button.getAttribute('aria-busy') === 'true') return;

      const entries = new Map(this.entries.map((e) => [e.id, e]));
      const toAdd = [];
      let needSize = 0;
      let soldOut = 0;

      this.list.querySelectorAll('[data-sedr-wl-item]').forEach((node) => {
        const entry = entries.get(Number(node.dataset.productId)) || {};
        const variants = this.variantsOf(node);

        if (node.dataset.available !== 'true') return soldOut++;

        let variant = null;
        if (entry.v) variant = variants.find((v) => v.id === entry.v) || null;
        if (!variant && variants.length === 1) variant = variants[0];

        if (!variant) return needSize++;
        if (!variant.available) return soldOut++;
        toAdd.push({ id: variant.id, product_id: Number(node.dataset.productId) });
      });

      button.setAttribute('aria-busy', 'true');
      let alreadyInCart = 0;
      let added = 0;
      let failed = false;

      try {
        // ما في السلة من قبل لا يُضاف مرة ثانية
        const cart = await (await sedrRequest(`${root}cart.js`)).json();
        const inCart = new Set((cart.items || []).map((i) => i.variant_id));
        const fresh = toAdd.filter((i) => {
          if (inCart.has(i.id)) {
            alreadyInCart++;
            return false;
          }
          return true;
        });

        if (fresh.length) {
          // الأقسام نفسها التي يطلبها نموذج المنتج في القالب
          const sections = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

          const post = (items, withSections = true) =>
            sedrRequest(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: items.map((i) => ({ id: i.id, quantity: 1 })),
                ...(withSections ? { sections: sections.join(','), sections_url: `${root}variants/${items[items.length - 1].id}` } : {}),
              }),
            }).catch((error) => {
              // A timed-out add may have succeeded. Show the server cart before another attempt.
              if (error.name === 'AbortError') window.location.href = `${root}cart`;
              throw error;
            });

          let response = await post(fresh);
          let renderedSections = null;
          let lastId = null;
          const addedItems = [];

          if (response.ok) {
            const json = await response.json();
            renderedSections = json.sections;
            added = fresh.length;
            lastId = fresh[fresh.length - 1].id;
            addedItems.push(...(json.items || []));
          } else if (response.status === 422) {
            // رُفضت الدفعة كلها لأن أحدها لم يعد متاحًا: واحدًا واحدًا بلا أقسام، ثم الأقسام مرة واحدة
            for (const item of fresh) {
              response = await post([item], false);
              if (response.ok) {
                const json = await response.json();
                added++;
                lastId = item.id;
                addedItems.push(...(json.items || [json]));
              } else if (response.status === 422) {
                soldOut++;
              } else {
                failed = true;
                break;
              }
            }
            if (added) {
              const rendered = await sedrRequest(`${root}variants/${lastId}?sections=${encodeURIComponent(sections.join(','))}`);
              if (rendered.ok) renderedSections = await rendered.json();
            }
          } else {
            failed = true;
          }

          if (added) {
            const cartContent = await (await sedrRequest(`${root}cart.js`)).json();
            cartContent.sections = renderedSections || {};

            if (window.themeVariables?.settings?.cartType === 'page') {
              window.location.href = `${root}cart`;
              return;
            }

            // من الجذر لا من الصفحة، كي لا يُحسب مرتين في قياس بطاقات الصفحة
            document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: addedItems, cart: cartContent } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
            track('add_all_to_cart', { count: added, source: this.isShared ? 'shared' : 'page' });
          }
        }
      } catch (e) {
        failed = true;
      }

      button.removeAttribute('aria-busy');

      const messages = [];
      if (failed) messages.push(S.addError);
      if (added) messages.push(t('addedSome', { count: countPhrase(added) }));
      if (alreadyInCart) messages.push(t('alreadyInCart', { count: countPhrase(alreadyInCart) }));
      if (needSize) messages.push(t('needSize', { count: countPhrase(needSize) }));
      if (soldOut) messages.push(t('unavailable', { count: countPhrase(soldOut) }));
      if (!failed && !added && !alreadyInCart && !needSize && !soldOut) messages.push(S.nothingToAdd);
      this.announce(messages.join(' '));

      // إبراز البطاقات التي تحتاج اختيار الحجم
      if (needSize) {
        this.list.querySelectorAll('[data-sedr-wl-item]').forEach((node) => {
          const entry = entries.get(Number(node.dataset.productId)) || {};
          const variants = this.variantsOf(node);
          const hasVariant = (entry.v && variants.some((v) => v.id === entry.v)) || variants.length === 1;
          if (node.dataset.available === 'true' && !hasVariant) {
            const note = node.querySelector('[data-sedr-wl-note]');
            if (note && !note.querySelector('.is-attention')) {
              const span = document.createElement('span');
              span.className = 'is-attention';
              span.textContent = S.chooseSize;
              note.appendChild(span);
              note.hidden = false;
            }
          }
        });
      }
    }

    toggleShare(open = this.shareForm?.hidden) {
      if (!this.shareForm) return this.share();
      this.shareForm.hidden = !open;
      this.shareButton.setAttribute('aria-expanded', String(Boolean(open)));
      if (open) {
        if (!this.nameInput.value) this.nameInput.value = readName();
        this.nameInput.focus();
      }
    }

    async share() {
      const items = this.entries;
      if (!items.length) return;

      const name = cleanName(this.nameInput?.value, true);
      if (this.nameInput) this.nameInput.value = name;
      saveName(name);

      let url = `${window.location.origin}${config.pageUrl}&shared=${encodeShared(items)}`;
      if (name) url += `&name=${encodeURIComponent(name)}`;
      const text = name ? S.shareTextNamed.replace('{name}', name) : S.shareText;
      const done = (method) => {
        track('share', { count: items.length, method, named: Boolean(name) });
        this.toggleShare(false);
        this.shareButton?.focus();
      };

      if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
        try {
          await navigator.share({ title: text, text, url });
          done('native');
        } catch (e) {}
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        Toast.show(S.copied);
        done('copy');
      } catch (e) {
        Toast.show(S.copyFailed, null, { stay: true });
      }
    }

    saveShared() {
      let saved = 0;
      let full = false;
      const entries = new Map(this.shared.map((e) => [e.id, e]));
      const now = Date.now();

      this.list.querySelectorAll('[data-sedr-wl-item]').forEach((node, index) => {
        const id = Number(node.dataset.productId);
        const entry = entries.get(id) || {};
        const variant = entry.v ? this.variantsOf(node).find((v) => v.id === entry.v) : null;
        const result = Store.add({
          id,
          h: node.dataset.handle,
          v: variant ? variant.id : null,
          p: variant ? variant.price : Number(node.dataset.price),
          t: now - index,
        });
        if (result === 'added') saved++;
        if (result === 'full') full = true;
      });

      if (full) Toast.show(S.full, { label: S.view, href: config.pageUrl }, { duration: 6000, stay: true });
      else Toast.show(S.savedShared, { label: S.view, href: config.pageUrl }, { icon: 'filled' });
      if (saved) track('save_shared', { count: saved });
    }

    clear() {
      if (!window.confirm(S.clearConfirm)) return;
      Store.clear();
      track('clear');
    }
  }

  /* ------------------------------------------------------------------ «من مفضلتك» في السلة */

  const stripCache = new Map();
  let stripViewed = false;

  class SedrWishlistStrip extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this._loaded = false;
      this._load = this._load.bind(this);

      // تغيّرت المفضلة بعد رسم الشريط (إزالة من تبويب المفضلة في الدرج نفسه مثلًا): ما أُزيل يغيب فورًا بلا طلب، ثم يُعاد الرسم
      this._onChange = () => {
        if (!this._loaded || this._ids().join() === this._shown) return;
        this.querySelectorAll('.sedr-wl-mini__item').forEach((el) => Store.has(Number(el.dataset.productId)) || el.remove());
        if (!this.querySelector('.sedr-wl-mini__item')) this._clear();
        this._loaded = false;
        this._load();
      };
      document.addEventListener('sedr:wishlist:change', this._onChange);

      this._onAdd = (event) => {
        (event.detail?.items || []).forEach((i) => track('item_to_cart', { productId: i.product_id, variantId: i.variant_id, source: 'cart_strip' }));
      };
      this.addEventListener('variant:add', this._onAdd);

      // يُطلب عند فتح السلة الجانبية فقط: حدث فتحها في القالب، ومعه المراقب احتياطًا
      const drawer = this.closest('[open]');
      if (drawer && drawer !== document.documentElement) return this._load();

      this._onShow = (event) => {
        if (event.target.contains(this)) this._load();
      };
      document.addEventListener('dialog:after-show', this._onShow);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((records) => {
          if (records.some((r) => r.isIntersecting)) this._load();
        });
        this.observer.observe(this.parentElement || this);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      if (this._onShow) document.removeEventListener('dialog:after-show', this._onShow);
      document.removeEventListener('sedr:wishlist:change', this._onChange);
      this.removeEventListener('variant:add', this._onAdd);
    }

    _ids() {
      const exclude = new Set(
        (this.getAttribute('exclude') || '')
          .split(',')
          .map(Number)
          .filter(Boolean)
      );
      return Store.items()
        .sort((a, b) => (b.t || 0) - (a.t || 0))
        .map((i) => i.id)
        .filter((id) => !exclude.has(id))
        .slice(0, 8);
    }

    _clear() {
      this.hidden = true;
      this.replaceChildren();
    }

    async _load() {
      if (this._loaded) return;
      this._loaded = true;
      this.observer?.disconnect();
      if (this._onShow) document.removeEventListener('dialog:after-show', this._onShow);

      const run = (this._run = (this._run || 0) + 1);
      const ids = this._ids();
      this._shown = ids.join();
      if (!ids.length) return this._clear();

      const url = searchSectionUrl(ids, 'sedr-wishlist-mini');
      let html = stripCache.get(url);
      if (!html) {
        try {
          const response = await sedrRequest(url, { priority: 'low' });
          if (!response.ok) return;
          html = await response.text();
          stripCache.set(url, html);
        } catch (e) {
          return;
        }
      }

      const found = new Map();
      parseHtml(html)
        .querySelectorAll('.sedr-wl-mini__item')
        .forEach((el) => found.set(Number(el.dataset.productId), el));
      const nodes = ids
        .filter((id) => found.has(id))
        .slice(0, 3)
        .map((id) => document.importNode(found.get(id), true));
      // طلب أحدث سبق هذا، أو خرج العنصر من الصفحة
      if (run !== this._run || !this.isConnected) return;
      if (!nodes.length) return this._clear();

      const header = document.createElement('div');
      header.className = 'sedr-wl-strip__header';
      const title = document.createElement('p');
      title.className = 'sedr-wl-strip__title';
      title.innerHTML = HEART_SVG;
      title.append(document.createTextNode(S.stripTitle));
      const all = document.createElement('a');
      all.className = 'sedr-wl-strip__all link';
      all.href = config.pageUrl;
      all.textContent = S.stripAll;
      header.append(title, all);

      const list = document.createElement('div');
      list.className = 'sedr-wl-strip__list';
      list.append(...nodes);

      this.replaceChildren(header, list);
      this.hidden = false;
      if (!stripViewed) track('strip_view', { count: nodes.length });
      stripViewed = true;
    }
  }

  /* ------------------------------------------------------------------ قياس الشراء من المفضلة */

  // أي إضافة إلى السلة (من أي موضع) لمنتج محفوظ في المفضلة
  document.addEventListener('variant:add', (event) => {
    const items = event.detail?.items || [];
    items.forEach((i) => {
      if (Store.has(i.product_id)) track('saved_item_to_cart', { productId: i.product_id, variantId: i.variant_id });
    });
  });

  /* ------------------------------------------------------------------ التذكير عند العودة */

  const REMIND_KEY = 'sedr:wishlist:reminded';
  const SESSION_KEY = 'sedr:wishlist:session';
  const REMIND_EVERY = 3 * 24 * 60 * 60 * 1000;

  const maybeRemind = () => {
    let firstPage = false;
    try {
      firstPage = !sessionStorage.getItem(SESSION_KEY);
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      return;
    }
    if (!firstPage) return;

    const count = Store.count();
    if (!count) return;
    if (document.querySelector('sedr-wishlist-page')) return;
    if (window.themeVariables?.settings?.pageType === 'cart') return;

    try {
      const last = Number(localStorage.getItem(REMIND_KEY) || 0);
      if (Date.now() - last < REMIND_EVERY) return;
      // لا تذكير في زيارة حفظ فيها الزائر للتو
      const newest = Math.max(...Store.items().map((i) => i.t || 0));
      if (Date.now() - newest < 60 * 60 * 1000) return;
    } catch (e) {
      return;
    }

    setTimeout(() => {
      try {
        localStorage.setItem(REMIND_KEY, String(Date.now()));
      } catch (e) {}
      Toast.show(t('reminder', { count: countPhrase(count) }), { label: S.reminderCta, href: config.pageUrl }, { duration: 10000, closable: true, icon: 'filled' });
      track('reminder_view', { count });
    }, 3500);
  };

  /* ------------------------------------------------------------------ التسجيل */

  // قبل تعريف العناصر، فتُرسم أول مرة بقائمة الحساب. وخلل فيها لا يعطّل المفضلة في المتصفح
  try {
    Sync.boot();
  } catch (e) {}

  const define = (name, cls) => {
    if (!window.customElements.get(name)) window.customElements.define(name, cls);
  };

  define('sedr-wishlist-button', SedrWishlistButton);
  define('sedr-wishlist-count', SedrWishlistCount);
  define('sedr-wishlist-page', SedrWishlistPage);
  define('sedr-wishlist-strip', SedrWishlistStrip);

  // request وsectionUrl وtrack لتبويب المفضلة في درج السلة (sedr-cart-tabs.js، STR-159)
  window.SedrWishlist = { ...Store, countPhrase, toast: Toast.show, request: sedrRequest, sectionUrl: searchSectionUrl, track };

  const init = () => {
    Toast.ensureLive();
    maybeRemind();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
